module.exports = __webpack_public_path__ + "img/yichehui.d8ebf22c.png";